<template>
    <Card class="mb-3 border-0 shadow-sm">
        <div class="row align-items-center">
            <div class="col-md-6 py-2">
                <div class="fs-4 title" v-if="$slots.default"><slot/></div>
                <div class="fs-6 description" v-if="$slots.description"><slot name="description"/></div>
            </div>
            <div class="col-md-6 text-md-end">
                <div class="mt-3 mt-md-0" v-if="$slots.right">
                    <slot name="right" />
                </div>

            </div>
        </div>
    </Card>
</template>

<script setup lang="ts">
import Card from "@/components/elements/Card.vue";
</script>

<style scoped>
    .title {
        line-height: 1.2rem;
        margin-bottom: 0;
    }

    .description {
        margin-bottom: 0;
    }
</style>
